import React from 'react';
import styled from 'astroturf/react';
import $image_url from 'js/utils/image_url';
import { Body } from 'js/design_system/Body';

// Footer that could be added to modals for a "people from these universities have upgraded".
// Uses white text if dark=false. (Other colors not hardcoded, so this should
// be reusable on different dark backgrounds. It's currently used on a dark blue.)
// Pass dark=true to use on light backgrounds.

// This component is designed for exactly three universities, so styles will need to be adjusted
// if this list is updated to have more or less than three universities.
const university_logos_white = [
  {
    alt: 'Oxford',
    url: 'flexible_premium_upgrade/oxford-white.svg',
  },
  {
    alt: 'Berkeley',
    url: 'flexible_premium_upgrade/berkeley-white.svg',
  },
  {
    alt: 'UNAM',
    url: 'flexible_premium_upgrade/unam-white.svg',
  },
];

const university_logos_dark = [
  {
    alt: 'Oxford',
    url: 'emails/logos/oxford-black.png',
  },
  {
    alt: 'Berkeley',
    url: 'emails/logos/berkeley-black.png',
  },
  {
    alt: 'UNAM',
    url: 'emails/logos/unam-black.png',
  },
];

const LargerLineHeightBody = styled(Body)<{ dark: boolean }>`
  line-height: 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  width: fit-content;
  margin-top: 32px;
  margin-bottom: 24px;
  @media (min-width: $ds-tablet-sm) {
    margin-bottom: 16px;
  }
  @media (min-width: $ds-desktop-sm) {
    line-height: 28px;
  }

  &.dark {
    color: var(--text-primary, #141413);
  }
`;

const SocialProofOuterSection = styled.div`
  padding: 0 16px 24px;
  @media (min-width: $ds-tablet-sm) {
    padding: 0 32px 32px;
  }
  @media (min-width: $ds-desktop-sm) {
    padding: 0 48px 40px;
  }
`;

const SocialProofInnerSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UniversityImagesContainer = styled.div<{ narrowGap?: boolean }>`
  display: grid;
  width: fit-content;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 24px;
  @media (min-width: $ds-tablet-sm) {
    grid-template-rows: unset;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 32px;
  }
  @media (min-width: $ds-desktop-sm) {
    gap: 51px;
  }

  &.narrowGap {
    gap: 24px;
  }
`;

const UniversityImage = styled.img`
  height: 44px;
  @media (min-width: $ds-tablet-sm) and (max-width: $ds-desktop-sm - 1px) {
    height: 37px;
  }
`;

const SocialProofUniversityFooter: React.FC<{
  header: string;
  includeTopBorder: boolean;
  dark?: boolean;
  narrowGap?: boolean;
}> = ({ header, includeTopBorder, dark, narrowGap }) => {
  const university_logos = dark
    ? university_logos_dark
    : university_logos_white;
  return (
    <SocialProofOuterSection>
      <SocialProofInnerSection
        style={includeTopBorder ? { borderTop: '1px solid #8494b2' } : {}}
      >
        <LargerLineHeightBody bold dark={dark}>
          {header}
        </LargerLineHeightBody>
        <UniversityImagesContainer narrowGap={narrowGap}>
          {university_logos.map((logo, idx) => {
            return (
              <UniversityImage
                key={idx}
                src={$image_url(logo.url)}
                alt={logo.alt}
              />
            );
          })}
        </UniversityImagesContainer>
      </SocialProofInnerSection>
    </SocialProofOuterSection>
  );
};

export default SocialProofUniversityFooter;
